export const DIRECTIONS = {
  UP: 'up',
  DOWN: 'down'
};
/**
 * Starting from `target`, transitively collects all entries from `allBoundingBoxes`
 * whose row range overlaps with the collected entries' row range. Column position
 * is ignored — only row overlap drives grouping.
 */
export function computePegboardRowGroup(target, allBoundingBoxes) {
  const sorted = allBoundingBoxes.toSorted((a, b) => a.rowTop - b.rowTop);
  let group = [];
  let groupRowTop = 0;
  let groupRowBottom = -Infinity;
  let foundTarget = false;
  for (const bbox of sorted) {
    if (bbox.rowTop > groupRowBottom) {
      // If we've already found the target, the next element past the group's
      // row bottom is not part of the group
      if (foundTarget) break;

      // Otherwise, start a new group
      group = [];
      groupRowTop = bbox.rowTop;
      groupRowBottom = bbox.rowBottom;
      foundTarget = false;
    } else {
      groupRowBottom = Math.max(groupRowBottom, bbox.rowBottom);
    }
    group.push(bbox);
    if (bbox.id === target.id) foundTarget = true;
  }
  return {
    group,
    ids: new Set(group.map(bbox => bbox.id)),
    rowTop: groupRowTop,
    rowBottom: groupRowBottom,
    height: groupRowBottom - groupRowTop + 1
  };
}

/**
 * Returns the closest box strictly above `targetGroup.rowTop`, or null if none.
 */
export function findNearestUpwardPegboardNeighbor(boundingBoxes, targetGroup) {
  return boundingBoxes.reduce((closest, bbox) => {
    if (bbox.rowBottom >= targetGroup.rowTop) return closest;
    if (closest === null || bbox.rowBottom > closest.rowBottom) return bbox;
    return closest;
  }, null);
}

/**
 * Returns the closest box strictly below `targetGroup.rowBottom`, or null if none.
 */
export function findNearestDownwardPegboardNeighbor(boundingBoxes, targetGroup) {
  return boundingBoxes.reduce((closest, bbox) => {
    if (bbox.rowTop <= targetGroup.rowBottom) return closest;
    if (closest === null || bbox.rowTop < closest.rowTop) return bbox;
    return closest;
  }, null);
}
export function computeUpwardPegboardSwapPositions(targetGroup, neighborGroup) {
  const distanceBetweenGroups = targetGroup.rowTop - (neighborGroup.rowTop + neighborGroup.height);
  return {
    targetRowStarts: new Map(targetGroup.group.map(bbox => [bbox.id, neighborGroup.rowTop + (bbox.rowTop - targetGroup.rowTop)])),
    neighborRowStarts: new Map(neighborGroup.group.map(bbox => [bbox.id, bbox.rowTop + targetGroup.height + distanceBetweenGroups]))
  };
}
export function computeDownwardPegboardSwapPositions(targetGroup, neighborGroup) {
  const distanceBetweenGroups = neighborGroup.rowTop - (targetGroup.rowTop + targetGroup.height);
  return {
    targetRowStarts: new Map(targetGroup.group.map(bbox => [bbox.id, bbox.rowTop + neighborGroup.height + distanceBetweenGroups])),
    neighborRowStarts: new Map(neighborGroup.group.map(bbox => [bbox.id, targetGroup.rowTop + (bbox.rowTop - neighborGroup.rowTop)]))
  };
}